import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { Magnitude } from 'domain/entity/magnitude';
import ReadMagnitudesCriteria from 'use-case/magnitudes/read/readMagnitudesCriteria';

const getReadMagnitudesApiClient = getArrayApiClient(
    (criteria: ReadMagnitudesCriteria) => `dashboards/magnitudes/units?magnitudes=${criteria.magnitudes}`,
    Magnitude
);

export default getReadMagnitudesApiClient;
